import React, { useState } from "react";
import ui from "../DashboardUI.module.css";
import styles from "./DirectoryUI.module.css";
import { createExternalContact, updateExternalContact } from "../../../services/directoryService";
import { errorMessage } from "../../../utils/errorMessage";

const BLANK = { name: "", email: "", phone: "", job_title: "" };

// Contacts tab of the company form: everyone at the company, one-click primary, and an inline add.
export default function CompanyContactsTab({ company, canEdit, onChanged, onError }) {
  const [form, setForm] = useState(BLANK);
  const field = (key) => ({ value: form[key], onChange: (e) => setForm((prev) => ({ ...prev, [key]: e.target.value })) });
  const contacts = company.contacts || [];

  const run = async (change) => {
    try {
      await change();
      await onChanged();
    } catch (err) {
      onError(errorMessage(err, "Could not save the contact."));
    }
  };

  const add = () => run(async () => {
    await createExternalContact(company.client_company_id, { ...form, is_primary: contacts.length === 0 });
    setForm(BLANK);
  });

  const makePrimary = (contact) => run(() => updateExternalContact(contact.client_contact_id, { ...contact, is_primary: true }));

  return (
    <div>
      {contacts.length === 0 ? (
        <p className={styles.tabEmpty}>No contacts at this company yet.</p>
      ) : (
        <div className={styles.tabList}>
          {contacts.map((contact) => (
            <div key={contact.client_contact_id} className={ui.assignedItem}>
              <div className={ui.employeeInfo}>
                <span className={ui.employeeName}>{contact.name || "Unnamed contact"}</span>
                <span className={ui.employeeTitle}>
                  {[contact.job_title, contact.email, contact.phone].filter(Boolean).join(" · ") || "No details"}
                </span>
              </div>
              {contact.is_primary ? (
                <span className={ui.employeeRole}>Primary</span>
              ) : canEdit && (
                <button type="button" className={styles.rowAction} onClick={() => makePrimary(contact)}>
                  Make primary
                </button>
              )}
            </div>
          ))}
        </div>
      )}

      {canEdit && (
        <>
          <h4 className={styles.tabHeading}>Add a contact</h4>
          <div className={styles.addContactGrid}>
            <div className={ui.inputGroup}><label>Name:</label><input type="text" {...field("name")} /></div>
            <div className={ui.inputGroup}><label>Job title:</label><input type="text" {...field("job_title")} /></div>
            <div className={ui.inputGroup}><label>Email:</label><input type="email" {...field("email")} /></div>
            <div className={ui.inputGroup}><label>Phone:</label><input type="tel" {...field("phone")} /></div>
            <button type="button" className={ui.saveButton} disabled={!form.name.trim() && !form.email.trim()} onClick={add}>
              Add contact
            </button>
          </div>
        </>
      )}
    </div>
  );
}
